'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = clientMiddleware;

var _utils = require('helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clientMiddleware(client, ibonus) {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        var _getState = getState(),
            lang = _getState.lang;

        return function (next) {
            return function (action) {
                if (typeof action === 'function') {
                    return action(dispatch, getState);
                }

                var promise = action.promise,
                    types = action.types,
                    preloader = action.preloader,
                    rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'types', 'preloader']); // eslint-disable-line no-redeclare

                if (!promise) {
                    return next(action);
                }

                var show_preloader = false,
                    hide_preloader = false;

                if (preloader) {
                    show_preloader = true;
                    hide_preloader = true;
                }

                var _types = (0, _slicedToArray3.default)(types, 3),
                    REQUEST = _types[0],
                    SUCCESS = _types[1],
                    FAILURE = _types[2];

                next((0, _extends3.default)({}, rest, { show_preloader: show_preloader, type: REQUEST }));

                var actionPromise = promise(client, ibonus, { dispatch: dispatch, getState: getState });
                actionPromise.then(function (result) {
                    next((0, _extends3.default)({}, rest, { result: result, hide_preloader: hide_preloader, show_error: false, type: SUCCESS }));
                }, function (err) {
                    var error = (0, _extends3.default)({}, err);

                    if (!error.message) {
                        error.message = (0, _utils.replaceCharToArrayIndex)(lang[error.title], error.dataError);
                    }
                    next((0, _extends3.default)({}, rest, { error: error, hide_preloader: hide_preloader, show_error: true, type: FAILURE }));
                }).catch(function (err) {
                    console.error('MIDDLEWARE ERROR:', err);

                    var error = (0, _extends3.default)({}, err);

                    //На тесте приходит message в ошибке, а на бою нет
                    if (!error.message) {
                        error.message = (0, _utils.replaceCharToArrayIndex)(lang[error.title], error.dataError);
                    }

                    next((0, _extends3.default)({}, rest, { error: error, hide_preloader: hide_preloader, show_error: true, type: FAILURE }));
                });

                return actionPromise;
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/clientMiddleware.js
// module id = 1887
// module chunks = 0